// Mock product catalog for acuadros.co
// Real pricing — los precios son por tamaño (cuadro en MDF impreso).

export const FRAMES = [
  { id: "negro", label: "Marco negro", hex: "#0F172A" },
  { id: "blanco", label: "Marco blanco", hex: "#F8FAFC" },
  { id: "madera", label: "Madera natural", hex: "#B58A5F" },
  { id: "sin-marco", label: "Sin marco", hex: "transparent" },
];

// Precios oficiales de acuadros.co por tamaño (cuadro en MDF).
// Incluyen la comisión de la pasarela de pagos:
// precio = ceil_a_10000(base × 1.10 + 5000) sobre la base 40/50/80/90 mil.
export const SIZES = [
  { id: "s", label: "20x30 cm", price: 50000 },
  { id: "m", label: "30x40 cm", price: 60000 },
  { id: "l", label: "50x70 cm", price: 100000 },
  { id: "xl", label: "60x80 cm", price: 110000 },
];

const u = (id, w = 900) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

// `category` debe coincidir exactamente con CATEGORIES[].name (categories.js);
// `categorySlug` con CATEGORIES[].slug. Catálogo mock: 4 cuadros por categoría.
export const products = [
  // ── Abstracto ──────────────────────────────────────────────
  {
    id: 1,
    title: "Abstracción Geométrica",
    defaultSize: "m",
    description:
      "Composición geométrica en tonos sobrios, impresa sobre MDF de alta calidad. Estructura cualquier espacio sin saturarlo.",
    image:
      "https://images.pexels.com/photos/545575/pexels-photo-545575.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
    category: "Abstracto",
    categorySlug: "abstracto",
    bestseller: true,
  },
  {
    id: 3,
    title: "Líneas Minimalistas",
    defaultSize: "l",
    description:
      "Trazo único en tinta sobre fondo neutro. Estética escandinava para espacios contemporáneos.",
    image:
      "https://images.pexels.com/photos/8251473/pexels-photo-8251473.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
    category: "Abstracto",
    categorySlug: "abstracto",
  },
  {
    id: 5,
    title: "Rostro del Tiempo",
    defaultSize: "xl",
    description:
      "Estudio expresionista de luz y sombra. Una pieza statement para muros amplios.",
    image:
      "https://images.unsplash.com/photo-1547410518-bac44f7a9f5c?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900",
    category: "Abstracto",
    categorySlug: "abstracto",
  },
  {
    id: 7,
    title: "Trazo Sereno",
    defaultSize: "l",
    description:
      "Pincelada amplia y meditativa. Color pleno para activar un rincón monocromático.",
    image:
      "https://images.pexels.com/photos/1647116/pexels-photo-1647116.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
    category: "Abstracto",
    categorySlug: "abstracto",
  },

  // ── Mascotas ───────────────────────────────────────────────
  {
    id: 2,
    title: "Retrato Canino Elegante",
    defaultSize: "s",
    description:
      "Retrato pictórico con paleta cálida que captura el carácter de tu mejor amigo. Perfecto como regalo significativo.",
    image:
      "https://images.unsplash.com/photo-1546361897-9103555dd95c?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900",
    category: "Mascotas",
    categorySlug: "mascotas",
    bestseller: true,
  },
  {
    id: 4,
    title: "Dúo Peludo",
    defaultSize: "m",
    description:
      "Dos compañeros, una sola obra. Composición ideal para familias multimascota.",
    image:
      "https://images.unsplash.com/photo-1555628510-5e8e0a09a667?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900",
    category: "Mascotas",
    categorySlug: "mascotas",
  },
  {
    id: 6,
    title: "Silueta de Descanso",
    defaultSize: "s",
    description:
      "Retrato íntimo en clave baja. Captura el momento de calma que define a las mascotas en casa.",
    image:
      "https://images.unsplash.com/photo-1757009631885-675846efc740?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=900",
    category: "Mascotas",
    categorySlug: "mascotas",
  },
  {
    id: 8,
    title: "Mirada Fiel",
    defaultSize: "m",
    description:
      "Primer plano vibrante sobre fondo plano. Aporta personalidad y un punto focal claro.",
    image:
      "https://images.unsplash.com/photo-1583511655826-05700d52f4d9?auto=format&fit=crop&w=900&q=80",
    category: "Mascotas",
    categorySlug: "mascotas",
  },

  // ── Paisajes & Naturaleza ──────────────────────────────────
  {
    id: 9,
    title: "Amanecer en la Cordillera",
    defaultSize: "xl",
    description:
      "Montañas en bruma al primer sol. Profundidad inmediata para salas y espacios amplios.",
    image: u("1506905925346-21bda4d32df4"),
    category: "Paisajes & Naturaleza",
    categorySlug: "paisajes",
    bestseller: true,
  },
  {
    id: 10,
    title: "Bosque de Niebla",
    defaultSize: "l",
    description:
      "Pinos entre neblina en tonos fríos. Calma visual que se siente apenas entras.",
    image: u("1441974231531-c6227db76b6e"),
    category: "Paisajes & Naturaleza",
    categorySlug: "paisajes",
  },
  {
    id: 11,
    title: "Lago en Silencio",
    defaultSize: "m",
    description:
      "Reflejo perfecto de montaña sobre agua quieta. El punto de fuga que tu pared necesita.",
    image: u("1470071459604-3b5ec3a7fe05"),
    category: "Paisajes & Naturaleza",
    categorySlug: "paisajes",
  },
  {
    id: 12,
    title: "Cabaña al Atardecer",
    defaultSize: "l",
    description:
      "Luz dorada sobre paisaje abierto. Una ventana cálida a la vida lenta.",
    image: u("1501785888041-af3ef285b470"),
    category: "Paisajes & Naturaleza",
    categorySlug: "paisajes",
  },

  // ── Minimalista ────────────────────────────────────────────
  {
    id: 13,
    title: "Arco y Sombra",
    defaultSize: "m",
    description:
      "Arquitectura esencial en blanco cálido. Para espacios que respiran.",
    image: u("1449247709967-d4461a6a6103"),
    category: "Minimalista",
    categorySlug: "minimalista",
    bestseller: true,
  },
  {
    id: 14,
    title: "Línea Continua",
    defaultSize: "s",
    description:
      "Un solo trazo, un solo gesto. La pieza que ordena todo lo que tiene alrededor.",
    image:
      "https://images.pexels.com/photos/6492397/pexels-photo-6492397.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
    category: "Minimalista",
    categorySlug: "minimalista",
  },
  {
    id: 15,
    title: "Geometría en Calma",
    defaultSize: "l",
    description:
      "Planos suaves y proporción precisa. Diseño nórdico que nunca cansa.",
    image: u("1554188248-986adbb73be4"),
    category: "Minimalista",
    categorySlug: "minimalista",
  },
  {
    id: 16,
    title: "Horizonte Mínimo",
    defaultSize: "m",
    description:
      "Mar y cielo reducidos a dos franjas. Serenidad pura para dormitorios.",
    image: u("1505144808419-1957a94ca61e"),
    category: "Minimalista",
    categorySlug: "minimalista",
  },

  // ── Botánico ───────────────────────────────────────────────
  {
    id: 17,
    title: "Monstera en Luz",
    defaultSize: "m",
    description:
      "Hojas tropicales a contraluz. El verde que le faltaba a tu estudio.",
    image: u("1463320726281-696a485928c7"),
    category: "Botánico",
    categorySlug: "botanico",
    bestseller: true,
  },
  {
    id: 18,
    title: "Helechos de Sombra",
    defaultSize: "l",
    description:
      "Texturas vegetales en verde profundo. Frescura natural sin necesidad de regar.",
    image: u("1416339306562-f3d12fefd36f"),
    category: "Botánico",
    categorySlug: "botanico",
  },
  {
    id: 19,
    title: "Eucalipto Suave",
    defaultSize: "s",
    description:
      "Ramas en tonos salvia sobre fondo claro. Combina con todo, satura nada.",
    image: u("1466692476868-aef1dfb1e735"),
    category: "Botánico",
    categorySlug: "botanico",
  },
  {
    id: 20,
    title: "Jardín Ilustrado",
    defaultSize: "m",
    description:
      "Flora dibujada en estilo vintage. Un clásico botánico para comedores y cocinas.",
    image: u("1502082553048-f009c37129b9"),
    category: "Botánico",
    categorySlug: "botanico",
  },

  // ── Frases & Tipografía ────────────────────────────────────
  {
    id: 21,
    title: "Hazlo con Ganas",
    defaultSize: "s",
    description:
      "Letras grandes, mensaje directo. El empujón diario en tu espacio de trabajo.",
    image: u("1504805572947-34fad45aed93"),
    category: "Frases & Tipografía",
    categorySlug: "frases",
    bestseller: true,
  },
  {
    id: 22,
    title: "Respira",
    defaultSize: "m",
    description:
      "Una sola palabra en composición limpia. Pausa visual para cualquier rincón.",
    image: u("1455390582262-044cdead277a"),
    category: "Frases & Tipografía",
    categorySlug: "frases",
  },
  {
    id: 23,
    title: "Letras de Neón",
    defaultSize: "l",
    description:
      "Tipografía luminosa con actitud. Energía nocturna para salas y estudios.",
    image: u("1517842645767-c639042777db"),
    category: "Frases & Tipografía",
    categorySlug: "frases",
  },
  {
    id: 24,
    title: "Manifiesto en Tinta",
    defaultSize: "m",
    description:
      "Caligrafía expresiva en alto contraste. Para los que dicen lo que piensan.",
    image: u("1499951360447-b19be8fe80f5"),
    category: "Frases & Tipografía",
    categorySlug: "frases",
  },

  // ── Ciudades & Mapas ───────────────────────────────────────
  {
    id: 25,
    title: "Skyline al Anochecer",
    defaultSize: "xl",
    description:
      "La ciudad encendiéndose vista desde arriba. Para los que aman el ruido bonito.",
    image: u("1477959858617-67f85cf4f1df"),
    category: "Ciudades & Mapas",
    categorySlug: "ciudades",
    bestseller: true,
  },
  {
    id: 26,
    title: "Calles de Nueva York",
    defaultSize: "l",
    description:
      "Avenidas infinitas en perspectiva. Un clásico urbano que no pasa de moda.",
    image: u("1480714378408-67cf0d13bc1b"),
    category: "Ciudades & Mapas",
    categorySlug: "ciudades",
  },
  {
    id: 27,
    title: "Mapa de tu Ciudad",
    defaultSize: "m",
    description:
      "Cartografía lineal en tinta. Pide el mapa del lugar que te marcó.",
    image: u("1524661135-423995f22d0b"),
    category: "Ciudades & Mapas",
    categorySlug: "ciudades",
  },
  {
    id: 28,
    title: "Noche Urbana",
    defaultSize: "l",
    description:
      "Luces largas y asfalto mojado. Cine urbano para tu pared.",
    image: u("1514565131-fce0801e5785"),
    category: "Ciudades & Mapas",
    categorySlug: "ciudades",
  },

  // ── Retratos & Familia ─────────────────────────────────────
  {
    id: 29,
    title: "Retrato a Color",
    defaultSize: "m",
    description:
      "Tu foto favorita convertida en retrato pictórico. El regalo que nadie olvida.",
    image: u("1529626455594-4ff0802cfb7e"),
    category: "Retratos & Familia",
    categorySlug: "retratos",
    bestseller: true,
  },
  {
    id: 30,
    title: "Manos que se Encuentran",
    defaultSize: "s",
    description:
      "Detalle íntimo en blanco y negro. Minimalismo emocional para parejas.",
    image: u("1511895426328-dc8714191300"),
    category: "Retratos & Familia",
    categorySlug: "retratos",
  },
  {
    id: 31,
    title: "Tarde en Familia",
    defaultSize: "l",
    description:
      "Momentos cotidianos elevados a obra. Porque lo simple es lo que más se extraña.",
    image: u("1511671782779-c97d3d27a1d4"),
    category: "Retratos & Familia",
    categorySlug: "retratos",
  },
  {
    id: 32,
    title: "Generaciones",
    defaultSize: "m",
    description:
      "Tres edades, una sola historia. El cuadro que preside la sala de la abuela.",
    image: u("1609220136736-443140cffec6"),
    category: "Retratos & Familia",
    categorySlug: "retratos",
  },

  // ── Infantil ───────────────────────────────────────────────
  {
    id: 33,
    title: "Globo Aerostático",
    defaultSize: "m",
    description:
      "Ilustración tierna en pasteles suaves. Sueños grandes para cuartos pequeños.",
    image: u("1519689680058-324335c77eba"),
    category: "Infantil",
    categorySlug: "infantil",
    bestseller: true,
  },
  {
    id: 34,
    title: "Safari de Acuarela",
    defaultSize: "s",
    description:
      "Animales amigables en acuarela. El compañero de pared de sus primeros años.",
    image: u("1566004100631-35d015d6a491"),
    category: "Infantil",
    categorySlug: "infantil",
  },
  {
    id: 35,
    title: "Luna y Estrellas",
    defaultSize: "m",
    description:
      "Cielo nocturno ilustrado en tonos calmos. Para que dormir sea más fácil.",
    image: u("1503454537195-1dcabb73ffb9"),
    category: "Infantil",
    categorySlug: "infantil",
  },
  {
    id: 36,
    title: "Pequeño Explorador",
    defaultSize: "l",
    description:
      "Aventuras dibujadas con color y humor. Crece con ellos sin verse infantiloide.",
    image: u("1596464716127-f2a82984de30"),
    category: "Infantil",
    categorySlug: "infantil",
  },

  // ── Religioso & Espiritual ─────────────────────────────────
  {
    id: 37,
    title: "Luz de Vitral",
    defaultSize: "l",
    description:
      "Color y fe en una sola imagen. Serenidad que acompaña el hogar.",
    image: u("1438232992991-995b7058bbb3"),
    category: "Religioso & Espiritual",
    categorySlug: "religioso",
    bestseller: true,
  },
  {
    id: 38,
    title: "Velas en Oración",
    defaultSize: "s",
    description:
      "Llamas cálidas en penumbra. Un rincón de recogimiento para tu casa.",
    image: u("1544427920-c49ccfb85579"),
    category: "Religioso & Espiritual",
    categorySlug: "religioso",
  },
  {
    id: 39,
    title: "Amanecer de Gracia",
    defaultSize: "m",
    description:
      "Cielo abierto y luz primera. Esperanza visual para empezar el día.",
    image: u("1490730141103-6cac27aaab94"),
    category: "Religioso & Espiritual",
    categorySlug: "religioso",
  },
  {
    id: 40,
    title: "Versículo Enmarcado",
    defaultSize: "m",
    description:
      "Tu pasaje favorito en composición tipográfica. Pídelo con el texto que eliges tú.",
    image: u("1615529182904-14819c35db37"),
    category: "Religioso & Espiritual",
    categorySlug: "religioso",
  },

  // ── Música & Cine ──────────────────────────────────────────
  {
    id: 41,
    title: "Vinilo en Movimiento",
    defaultSize: "m",
    description:
      "El ritual análogo en primer plano. Para melómanos de tornamesa.",
    image: u("1470225620780-dba8ba36b745"),
    category: "Música & Cine",
    categorySlug: "musica-cine",
    bestseller: true,
  },
  {
    id: 42,
    title: "Guitarra al Atardecer",
    defaultSize: "l",
    description:
      "Cuerdas y luz dorada. La energía del escenario en tu estudio.",
    image: u("1511379938547-c1f69419868d"),
    category: "Música & Cine",
    categorySlug: "musica-cine",
  },
  {
    id: 43,
    title: "Noche de Concierto",
    defaultSize: "xl",
    description:
      "Multitud, luces y bajos que retumban. Revive tu mejor noche cada día.",
    image: u("1493225457124-a3eb161ffa5f"),
    category: "Música & Cine",
    categorySlug: "musica-cine",
  },
  {
    id: 44,
    title: "Cinta de Cine",
    defaultSize: "m",
    description:
      "Fotogramas y nostalgia de sala oscura. Para cinéfilos de corazón.",
    image: u("1485846234645-a62644f84728"),
    category: "Música & Cine",
    categorySlug: "musica-cine",
  },

  // ── Deportes ───────────────────────────────────────────────
  {
    id: 45,
    title: "Cancha bajo las Luces",
    defaultSize: "l",
    description:
      "El estadio en su mejor momento. Pasión de local para tu cuarto o gimnasio.",
    image: u("1431324155629-1a6deb1dec8d"),
    category: "Deportes",
    categorySlug: "deportes",
    bestseller: true,
  },
  {
    id: 46,
    title: "Aro y Cielo",
    defaultSize: "m",
    description:
      "Baloncesto en contrapicado. Minimalismo deportivo con actitud.",
    image: u("1461896836934-ffe607ba8211"),
    category: "Deportes",
    categorySlug: "deportes",
  },
  {
    id: 47,
    title: "Ruta del Ciclista",
    defaultSize: "m",
    description:
      "Carretera abierta y piernas que no paran. Homenaje al deporte que nos une.",
    image: u("1517649763962-0c623066013b"),
    category: "Deportes",
    categorySlug: "deportes",
  },
  {
    id: 48,
    title: "Brazada Perfecta",
    defaultSize: "l",
    description:
      "Agua, técnica y disciplina congeladas en un instante. Para los que entrenan temprano.",
    image: u("1530549387789-4c1017266635"),
    category: "Deportes",
    categorySlug: "deportes",
  },
];

export const getProduct = (id) =>
  products.find((p) => String(p.id) === String(id));

export const getProductsByCategory = (slug) =>
  products.filter((p) => p.categorySlug === slug);

export const countByCategory = (slug) => getProductsByCategory(slug).length;

export const getSize = (id) => SIZES.find((s) => s.id === id) || SIZES[1];
export const getFrame = (id) =>
  FRAMES.find((f) => f.id === id) || FRAMES[0];

// Pricing is flat by size (MDF print + frame); independent of the artwork.
export const computeVariantPrice = (_unused, sizeId) => getSize(sizeId).price;
export const priceForSize = (sizeId) => getSize(sizeId).price;

export const formatCOP = (value) =>
  new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    maximumFractionDigits: 0,
  }).format(value);
